__turbopack_context__.v({
  "keyboard-inset-height": "layout-module-scss-module__7OKDyq__keyboard-inset-height",
  "main": "layout-module-scss-module__7OKDyq__main",
  "with-header": "layout-module-scss-module__7OKDyq__with-header",
  "wrapper": "layout-module-scss-module__7OKDyq__wrapper",
});
